import React, { useEffect } from 'react';
import AOS from 'aos'
import 'aos/dist/aos.css'

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 600,
      easing: 'ease-out-sine',
    })
  })
  //console.log(process.env);
  return (
    <div className="font-inter --font-architects-daughter antialiased bg-black text-gray-200 tracking-tight">
      <div className="flex flex-col min-h-screen overflow-hidden">
        {children}
      </div>
    </div>
  );
};
